import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles<void, "iconWrapper">()((theme, _params, classes) => ({
    root: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        background: "none",
        border: "none",
        paddingInline: theme.spacing(1),
        cursor: "pointer",
        textAlign: "left",
        font: "inherit",
        color: theme.palette.secondary.main,
        "&:hover": {
            background: "none",
            boxShadow: "none",
            [`& .${classes.iconWrapper}`]: {
                backgroundColor: theme.palette.action.hover,
            },
        },
    },
    rootDisabled: {
        cursor: "not-allowed",
        opacity: 0.6,
    },
    iconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 26,
        height: 26,
        borderRadius: "50%",
        border: `2px solid ${theme.palette.primary.main}`,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
        }),
    },
    plusIcon: {
        width: 14,
        height: 14,
        "& path": {
            fill: "currentColor",
        },
    },
    textBlock: {
        display: "flex",
        flexDirection: "column",
    },
    title: {
        fontWeight: theme.typography.fontWeightRegular,
    },
}));
